export default "__VITE_ASSET__DdNE0RMY__"